import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  PROCESS_PROCESSOR_REQUEST,
  PROCESS_PROCESSOR_SUCCESS,
  PROCESS_PROCESSOR_FAILURE,
  processProcessorSuccess,
  processProcessorFailure,
} from "../actions/processorAction";
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = `${getBaseUrl()}/api/processor`;

function* processProcessorSaga(action) {
  try {
    const response = yield call(axios.post, `${API_BASE_URL}/process`, action.payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    yield put(processProcessorSuccess(response.data));
  } catch (error) {
    yield put(processProcessorFailure(error.response?.data?.message || "Processing failed"));
  }
}

export default function* processorSaga() {
  yield takeLatest(PROCESS_PROCESSOR_REQUEST, processProcessorSaga);
}